/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFilterViewModel } from "../types/CourseFilterViewModel.ts";
import { eCompanyFilterTypeSchema } from "./eCompanyFilterTypeSchema.ts";

export const courseFilterViewModelSchema = z.object({
  filter: z.optional(
    z
      .lazy(() => eCompanyFilterTypeSchema)
      .describe("1 = Main | 2 = Company | 3 = All | "),
  ),
  companyId: z
    .number()
    .int()
    .describe(
      "ID da empresa usada no escopo Company. Ignorado quando o usuário autenticado é vinculado a uma empresa. Opcional.",
    )
    .nullish(),
  search: z
    .string()
    .describe(
      "Texto livre aplicado ao código e ao nome oficial do curso. Máximo de 200 caracteres. Opcional.",
    )
    .nullish(),
  active: z
    .boolean()
    .default(true)
    .describe(
      "Define se a listagem traz apenas cursos ativos. Informe null para trazer ativos e inativos. Opcional.",
    )
    .nullish(),
  pageNumber: z.optional(
    z.number().int().default(1).describe("Página da listagem. Mínimo 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  ),
}) as unknown as ToZod<CourseFilterViewModel>;
